import { useEffect } from 'react';
import { AccountId, UserId } from 'api/models';
import { pushes } from 'api/pushes';
import { UserChannel } from 'api/pushes/channels';
import { useAccount } from './use-account';
import { useLatest } from './use-latest';
import { useUser } from './use-user';
export const useUserWsUpdates = (handler, [action, objectType])=>{
    const { user: { userId } } = useUser();
    const { accountId } = useAccount();
    const latestHandler = useLatest(handler);
    useEffect(()=>{
        const channel = UserChannel(AccountId(accountId), UserId(userId));
        const subscription = pushes(channel, [
            action,
            objectType
        ]).subscribe(latestHandler);
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        accountId,
        userId,
        action,
        objectType,
        latestHandler
    ]);
};
